
const state = () => ({
  /**
   * This variable is the dialog's name.
   * @type String
   */
  dialog: null,

  /**
   * This variable is used to prevent 2 clicks in a row.
   * @type Boolean
   */
  locked: false,
})

const getters = {
  catalog: state => state.dialog == 'catalog',
  content: state => state.dialog == 'content',
  discounts: state => state.dialog == 'discounts',
  payment: state => state.dialog == 'payment',
}

const mutations = {
  _set (state, v) {
    state.dialog = v
  },

  lock (state) {
    state.locked = true
  },
  unlock (state) {
    state.locked = false
  },
}

const actions = {
  set ({ state, commit }, dialog) {
    if (state.locked) {
      return
    }
    commit('lock')
    commit('_set', dialog)
    setTimeout(() => commit('unlock'), dialog ? 175 : 100)
  },
  openCatalog ({ dispatch }) {
    dispatch('set', 'catalog')
  },
  openContent ({ dispatch }) {
    dispatch('set', 'content')
  },
  openDiscounts ({ dispatch }) {
    dispatch('set', 'discounts')
  },
  openPayment ({ dispatch }) {
    dispatch('set', 'payment')
  },
  close ({ dispatch }) {
    dispatch('set', null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
